
import { ASSET_TYPE_METADATA } from './asset-type.metadata';
import { AssetTypeBase } from './asset-type.model.base';
import { CrudEntity, CrudEntityConstructionOptions } from '@scisys-uim/uim-common';


export interface AssetType extends AssetTypeBase {
}

export interface AssetTypeTransient { }

export class AssetType extends CrudEntity<AssetType, number, AssetTypeTransient> implements AssetTypeTransient {
  constructor(source?: Partial<AssetType>, options?: CrudEntityConstructionOptions<AssetType, number, AssetTypeTransient>) {
    super(ASSET_TYPE_METADATA, source, options);
  }

  initialiseEntityDefaults() {
    super.initialiseEntityDefaults();
    this.electricalAspectRequirement = this.electricalAspectRequirement || 'OPTIONAL';
    this.maintenanceAspectRequirement = this.maintenanceAspectRequirement || 'OPTIONAL';
    this.mechanicalAspectRequirement = this.mechanicalAspectRequirement || 'OPTIONAL';
    this.periodicMaintenance = this.periodicMaintenance || false;
    this.routineMaintenance = this.routineMaintenance || false;
    this.visualInspection = this.visualInspection || false;
    this.wbv = this.wbv || false;
    this.havs = this.havs || false;
    this.transferOnApproval = this.transferOnApproval || false;
  }

  registerPropertyCalculators() {
    super.registerPropertyCalculators();
  }
}





